import React from 'react'
import Tooltip from 'components/tooltip'

const FallbackPopover = ({ className, ...props }) => (
    <Tooltip
        withPopover={true}
        {...(className ? { wrapperClassName: className } : null)}
        {...props} />
)

export default FallbackPopover